import { ChangeEvent, FC } from 'react'
import Input from '@/components/input/Input'

export interface InputSearchProps {
  value: string
  onChange: (value: ChangeEvent<HTMLInputElement>) => void
  label?: string
  placeholder?: string
  className?: string
}

export const _InputSearch: FC<InputSearchProps> = ({
  value,
  onChange,
  label,
  placeholder,
  className
}) => {
  return (
    <Input
      className={className}
      labelText={label}
      classNameContainer="w-full"
      placeholder={placeholder}
      name="search-textfield"
      value={value}
      onChange={onChange}
      leftIcon="search"
    />
  )
}
